import { z } from 'zod'

const BaseChannelSchema = z.object({
  avatar_url: z.string().nullable(),
  connected: z.boolean(),
  preview_keyword: z.string().nullable(),
})

export const manychatApiSchemas = {
  getPreviewState: {
    path: z.undefined(),
    query: z.object({
      share_hash: z.string(),
    }),
    response: z.object({
      channels: z.object({
        instagram: BaseChannelSchema.extend({
          // Note that business_id is a number in the API response, but it's a string in the state.
          // JS doesn't support a number this big that's why the string type was required.
          // Currently, for this request, it is unused but if it will be used then it should be changed to string in the backend.
          business_id: z.number().nullable(),
          username: z.string().nullable(),
        }).optional(),
        tiktok: BaseChannelSchema.extend({
          username: z.string(),
        }).optional(),
      }),
    }),
  },
}
